import { Component } from '@angular/core';
import { DataSource } from '@angular/cdk/collections';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { MatPaginator, MatSort } from '@angular/material';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import * as moment from 'moment';

export interface TripData {
  index: string;
  id: string;
  date: string;
  time: string;
  lane: string;
  farePaid: string;
  cardNumber: string;
  name: string;
}

export class TripHistoryDatabase {
  /** Stream that emits whenever the data has been modified. */
  dataChange: BehaviorSubject<TripData[]> = new BehaviorSubject<TripData[]>([]);
  get data(): TripData[] { return this.dataChange.value; }

  constructor() {
  }

  addTrips(rawTripData: any) {
    this.removeTrips();
    for (let trip of rawTripData) {
      this.addTrip(this.createNewTrip(trip.AccountId, trip.CardName, trip.TransactionDate, trip.Lane, trip.FairPaid, trip.CardNumber))
    }

  }
  removeTrips() {
    let copiedData = this.data.slice();
    copiedData.length = 0;
    this.dataChange.next(copiedData);
  }
  /** Adds a new trip to the database. */
  addTrip(trip: TripData) {
    const copiedData = this.data.slice();
    copiedData.push(trip);
    this.dataChange.next(copiedData);
  }
  /** Builds and returns a new Trip. */
  private createNewTrip(id: string, name: string, date: string, lane: string, farePaid: string, cardNumber: string) {
    return {
      index: (this.data.length).toString(),
      id: id,
      date: this.getDateFormat(date),
      time: this.getTimeFormat(date),
      lane: lane,
      farePaid: farePaid,
      cardNumber: this.formatCardNumber(cardNumber),
      name: name
    };
  }


  getTimeFormat(tripDate: string) {
    const tripDateArray = tripDate.split(' ');
    const tripTime = tripDateArray[1] + ' ' + tripDateArray[2];
    return tripTime;
  }

  getDateFormat(tripDate: string) {
    const tripDateArray = tripDate.split(' ');
    tripDate = tripDateArray[0];
    tripDate = moment(tripDate, 'MM-DD-YYYY').format("MM/DD/YYYY");
    return tripDate;

  }

  formatCardNumber(cardNumber: string) {

    let index = cardNumber.indexOf('_');

    if (index != -1) {
      let cardNumberArray = cardNumber.split('_');
      if (index === 26) {
        return cardNumberArray[1].replace(/\b0+/, "").substr(-10);
      } else {
        return cardNumberArray[0].replace(/\b0+/, "").substr(-10);
      }
    }

    //if 13 zeros trim zeros and last digit
    if (cardNumber.startsWith("00000000000000")) {
      return cardNumber.replace(/\b0+/, "");
    } else {
      return cardNumber.replace(/\b0+/, "").substr(-11, 10);
    }

  }
}


/**
 * Data source to provide what data should be rendered in the table. Note that the data source
 * can retrieve its data in any way. In this case, the data source is provided a reference
 * to a common data base, TripHistoryDatabase. It is not the data source's responsibility to manage
 * the underlying data. Instead, it only needs to take the data and send the table exactly what
 * should be rendered.
 */



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/shared/models/trip-history-database.ts